import { Component, Input, ViewChild, ViewContainerRef, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { DetailsFooterWindowComponent } from '../details-footer-window/details-footer-window.component';
import { DetailsWindowHeaderComponent } from '../details-window-header/details-window-header.component';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IncidentVisualizerComponent } from '../incident-visualizer/incident-visualizer.component';

@Component({
  selector: 'app-details-window',
  standalone: true,
  imports: [DetailsFooterWindowComponent, DetailsWindowHeaderComponent],
  templateUrl: './details-window.component.html',
  styleUrl: './details-window.component.css'
})
export class DetailsWindowComponent implements AfterViewInit {
  @Input() mapEntity: any;
  @Input() sessionMode: any;
  @ViewChild('attrContainer', { read: ViewContainerRef, static: true }) attrContainer!: ViewContainerRef;
 @Output() commandClicked = new EventEmitter<any>();

  commands: any[] = [];
  constructor(public activeModal: NgbActiveModal) {}

  ngAfterViewInit() {
    this.loadAttributes();
  }

  get attributes() {
    return (this.mapEntity && typeof this.mapEntity.getAttributes === 'function')
      ? this.mapEntity.getAttributes()
      : [];
  }

  loadAttributes() {
    this.attrContainer.clear();
    for (const attr of this.attributes) {
      const visualizer = attr.getVisualizer?.();
      if (visualizer && visualizer.component) {
        const componentRef = this.attrContainer.createComponent(visualizer.component);
        if (visualizer.inputs) {
          Object.entries(visualizer.inputs).forEach(([key, value]) => {
            (componentRef.instance as any)[key] = value;
          });
        }
      }
    }
  }

 onCommandClicked(index: number ,mapEntity:any) {
    this.commandClicked.emit(this.commands[index]);
    this.commands[index]?.execute(mapEntity);
  }
  onCloseWindow() {
    this.activeModal.close();
  }
}
